import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountUpModule } from 'ngx-countup';

import { HomeComponent } from './home.component';
import { HomeService } from './home.service';
import { CardModule } from '../shared/components/card/card.module';
import { ChartModule } from '../shared/components/chart/chart.module';

@NgModule({
    declarations: [
        HomeComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        CountUpModule,

        CardModule,
        ChartModule,

        RouterModule
    ],
    providers: [
      HomeService
    ]
})
export class HomeModule { }
